import { c as _c } from "react/compiler-runtime";
import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import { IcoDragAndDrop16, IcoImages24 } from '@onefootprint/icons';
import { IconButton } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import Image from 'next/image';
import type { ComparisonImage, SlotIndex } from './types';
type SourceTileProps = {
  image: ComparisonImage;
  selectedSlot: number;
  activeSlot: SlotIndex;
  onSelect: () => void;
};
const SourceTile = t0 => {
  const $ = _c(38);
  const {
    image,
    selectedSlot,
    activeSlot,
    onSelect
  } = t0;
  const t1 = `source:${image.id}`;
  let t2;
  if ($[0] !== image.id) {
    t2 = {
      imageId: image.id
    };
    $[0] = image.id;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      id: t1,
      data: t2
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    isDragging
  } = useDraggable(t3);
  let t4;
  if ($[5] !== transform) {
    t4 = CSS.Translate.toString(transform);
    $[5] = transform;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = {
      transform: t4
    };
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = selectedSlot >= 0 ? "border-accent" : "border-tertiary";
  const t7 = isDragging && "z-20 opacity-60";
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = cx("flex min-w-0 items-center gap-1 rounded-lg border bg-primary p-1.5", t6, t7);
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const t9 = `Drag ${image.label}`;
  let t10;
  if ($[12] !== attributes || $[13] !== listeners || $[14] !== setActivatorNodeRef || $[15] !== t9) {
    t10 = <IconButton ref={setActivatorNodeRef} icon={IcoDragAndDrop16} size="compact" className="touch-none cursor-grab" {...attributes} {...listeners} aria-label={t9} />;
    $[12] = attributes;
    $[13] = listeners;
    $[14] = setActivatorNodeRef;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const t11 = `Show ${image.label} in ${activeSlot === 0 ? "left" : "right"} slot`;
  const t12 = selectedSlot >= 0;
  let t13;
  if ($[17] !== image.label || $[18] !== image.src || $[19] !== image.status) {
    t13 = <span className="flex h-12 w-20 shrink-0 items-center justify-center overflow-hidden rounded-sm bg-secondary">{image.status === "ready" ? <Image src={image.src} alt={`${image.label} preview`} width={80} height={50} className="h-full w-full object-contain" unoptimized={true} draggable={false} /> : <IcoImages24 color="tertiary" />}</span>;
    $[17] = image.label;
    $[18] = image.src;
    $[19] = image.status;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== image.label) {
    t14 = <span className="min-w-0 flex-1 truncate text-caption-2 text-secondary">{image.label}</span>;
    $[21] = image.label;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== selectedSlot) {
    t15 = selectedSlot >= 0 && <span className="mr-1 flex size-5 shrink-0 items-center justify-center rounded-sm bg-secondary text-caption-2 text-secondary">{selectedSlot === 0 ? "L" : "R"}</span>;
    $[23] = selectedSlot;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== onSelect || $[26] !== t11 || $[27] !== t12 || $[28] !== t13 || $[29] !== t14 || $[30] !== t15) {
    t16 = <button type="button" onClick={onSelect} aria-label={t11} aria-pressed={t12} className="flex min-w-0 flex-1 items-center gap-2 rounded-default text-left hover:bg-hover focus-visible:outline-accent">{t13}{t14}{t15}</button>;
    $[25] = onSelect;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== setNodeRef || $[33] !== t10 || $[34] !== t16 || $[35] !== t5 || $[36] !== t8) {
    t17 = <div ref={setNodeRef} style={t5} className={t8}>{t10}{t16}</div>;
    $[32] = setNodeRef;
    $[33] = t10;
    $[34] = t16;
    $[35] = t5;
    $[36] = t8;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  return t17;
};
export type { SourceTileProps };
export default SourceTile;